export default "__VITE_ASSET__BEd3B5Qg__"